import BaseApi from "../../BaseApi";
import {headers} from "../../ApiSettings";

class FomMastic extends BaseApi {
    constructor() {
        super({suffix: ""});
    }

    GetAllFomMastik(params) {
        return this.httpService.get("Definition/all-foam-mastic", {headers, params})
    }

    EditPriceFomMastik(data) {
        return this.httpService.put("Definition/set-price-foam-mastic", data, {headers})
    }

    EditFomMastik(data) {
        return this.httpService.put("Definition/update-foam-mastic", data, {headers})
    }

    InsertFomMastikData(data) {
        return this.httpService.post("Definition/insert-foam-mastic", data, {headers})
    }

    deleteFomMastik(data) {
        return this.httpService.delete("Definition/delete-foam-mastic", {headers, data})
    }

    disableFomMastik(data) {
        return this.httpService.put("Definition/disable-foam-mastic", data, {headers})
    }

    getRelationFom(params) {
        return this.httpService.get("Definition/relation-foam-mastic", {headers, params})
    }
}

const FomMasticService = new FomMastic();
export default FomMasticService;

